import React from 'react';
import { CtaButton } from './CtaButton';
import { ShieldCheck, Clock, Zap, Lock, Tag } from 'lucide-react';
import { useLocale } from '../utils/locale';
export function FinalCtaSection() {
  const locale = useLocale();
  const isAR = locale === 'ar';
  return <section id="oferta-final" className="py-4 md:py-14 px-6 bg-navy text-center border-t border-white/10" data-id="element-63">
      <div className="max-w-3xl mx-auto" data-id="element-64">
        {/* Urgency Badge */}
        <div className="inline-flex items-center gap-2 bg-amber/20 text-amber px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-8" data-id="element-65">
          <Clock className="w-4 h-4" data-id="element-66" />
          <span data-id="element-67">Oferta por tiempo limitado</span>
        </div>

        {/* Emotional Headline */}
        <h2 className="text-4xl md:text-5xl font-bold text-background mb-6 leading-tight" data-id="element-68">
          Cada día que pasa, tu cuerpo sigue{' '}
          <span className="text-amber font-semibold" data-id="element-69">acumulando daño</span>.
        </h2>

        <p className="text-xl md:text-2xl text-background/80 mb-4 max-w-2xl mx-auto leading-relaxed" data-id="element-70">
          Mañana te vas a{' '}
          <strong className="text-background" data-id="element-71">
            despertar igual de cansado
          </strong>
          . La <strong className="text-background" data-id="element-72">niebla mental</strong> no se
          va sola. El{' '}
          <strong className="text-background" data-id="element-73">cansancio no se va solo</strong>.
        </p>

        <p className="text-xl text-amber font-semibold mb-10 max-w-2xl mx-auto" data-id="element-74">
          Pero en <strong data-id="element-75">72 horas</strong>,{' '}
          <strong data-id="element-76">todo puede ser diferente</strong>.
        </p>

        {/* Value + Pricing */}
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 mb-10 text-left max-w-xl mx-auto" data-id="element-77">
          <p className="text-amber text-sm uppercase tracking-wider font-bold mb-6" data-id="element-78">
            Lo que vas a obtener hoy
          </p>

          <div className="mb-8" data-id="element-79">
            <p className="text-background text-lg font-semibold leading-relaxed" data-id="element-80">
              El Manual Técnico Completo:{' '}
              <span className="text-amber" data-id="element-81">El Envés del Metabolismo</span>.
            </p>
            <p className="text-background/60 text-base mt-2 leading-relaxed" data-id="element-82">
              Incluye el Sistema de Reinicio, la Hoja de Ruta de 72hs y la
              Arquitectura de Energía Celular.
            </p>
          </div>

          {/* Pricing */}
          <div id="precio-final" className="border-t border-white/10 pt-6" data-id="element-83">
            <div className="flex flex-col items-center gap-3" data-id="element-84">
              <div className="flex items-center gap-3" data-id="element-85">
                <span className="text-background/40 text-xl line-through font-serif" data-id="element-86">
                  $18.988
                </span>
                <span className="bg-amber text-navy text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full flex items-center gap-1" data-id="element-87">
                  <Tag className="w-3 h-3" data-id="element-88" />
                  47% OFF
                </span>
              </div>
              <span className="text-amber font-bold text-5xl font-serif" data-id="element-89">
                <strong data-id="element-90">$9.997</strong>
              </span>
              <p className="text-background/50 text-sm mt-2 max-w-xs text-center leading-relaxed italic" data-id="element-91">
                Recuperar tu claridad mental hoy cuesta menos que un café con
                {isAR ? ' dos medialunas en la esquina' : ' un almuerzo rápido'}
                .
              </p>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <CtaButton href="https://vitalfoco.com/cart/44177187733564:1" className="w-full md:w-auto text-xl py-6 px-12 animate-cta-breathe" data-id="element-92">
          QUIERO RESETEAR MI SISTEMA AHORA
        </CtaButton>

        {/* Trust Signals */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 text-background/50 text-sm" data-id="element-93">
          <span className="flex items-center gap-2" data-id="element-94">
            <Lock className="w-4 h-4" data-id="element-95" />
            Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-96">
            <Zap className="w-4 h-4" data-id="element-97" />
            Acceso inmediato
          </span>
          <span className="flex items-center gap-2" data-id="element-98">
            <ShieldCheck className="w-4 h-4" data-id="element-99" />
            Garantía de 7 días
          </span>
        </div>

        {/* Risk Reversal / Guarantee */}
        <div className="mt-10 bg-accent/10 border border-accent/20 rounded-xl p-6 max-w-xl mx-auto text-left" data-id="element-100">
          <div className="flex items-start gap-4" data-id="element-101">
            <ShieldCheck className="w-10 h-10 text-accent flex-shrink-0 mt-1" data-id="element-102" />
            <div data-id="element-103">
              <p className="text-background font-bold mb-1" data-id="element-104">
                Garantía de Satisfacción de 7 Días
              </p>
              <p className="text-background/70 text-sm leading-relaxed" data-id="element-105">
                Si {isAR ? 'aplicás' : 'aplicas'} el protocolo y en{' '}
                <strong className="text-background" data-id="element-106">72 horas</strong>{' '}
                {isAR ? 'no notás' : 'no notas'}
                un cambio real en tu{' '}
                <strong className="text-background" data-id="element-107">
                  capacidad de enfoque
                </strong>{' '}
                y niveles de energía, {isAR ? 'me mandás' : 'me mandas'} un
                mensaje y te devuelvo el dinero. Mi reputación vale más que el
                costo de un desayuno.
              </p>
            </div>
          </div>
        </div>

        {/* Final Scarcity Line */}
        <p className="mt-10 text-background/40 text-sm italic" data-id="element-108">
          No sé cuánto tiempo más estará disponible a este precio. Si estás
          leyendo esto, todavía estás a tiempo.
        </p>
      </div>
    </section>;
}